module.exports = __webpack_public_path__ + "img/imgfftBR200.96855156.png";